















































import { Component, Prop, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import InputGroup from '@/mixins/form/inputGroup'
import { Worker } from '@/types/user'

export type EventWorkerInputType = {
  [workerId: number]: {
    value: boolean
    name: string
  }
}

@Component({
  components: {
    CheckboxInput: () => import('@/components/common/inputs/CheckboxInput.vue')
  }
})
export default class EventWorkerCheckboxInputGroup extends mixins(InputGroup) {
  @Prop({ default: () => [] }) readonly watchingWorkers!: Array<Worker>
  @Prop(Object) inputs!: EventWorkerInputType

  inputCheckedAll = false

  @Watch('inputCheckedAll')
  handleCheckAll(newValue: boolean) {
    Object.keys(this.inputs).map(
      id => (this.inputs[Number(id)].value = newValue)
    )
  }
}
